import apis from "../api"

export const info = {
  namespaced: true,
  state: {
    user: null
  },

  mutations: {
    SET(state, info) {
      state.user = info
    },

    CLEAR(state) {
      state.user = null
    }
  },

  actions: {
    get({ commit, dispatch }, key) {
      return new Promise((resolve, reject) => {
        apis.user.admin_details(key)
          .then(response => {
            commit("SET", response);
            resolve(response)
          })
          .catch(error => {
            dispatch('feedback/show', { message: error, color: 'error' }, { root: true })
            reject(error)
          })
      })
    },

    signup({ dispatch }, item) {
      return new Promise((resolve, reject) => {
        apis.user.signup(item)
          .then(response => {
            console.log(response);
            dispatch('feedback/show', { message: `User ${response.email} registered`, color: 'success' }, { root: true })
            resolve(response)
          })
          .catch(error => {
            dispatch('feedback/show', { message: error, color: 'error' }, { root: true })
            reject(error)
          })
      })
    },

    change() {

    }
  },

  getters: {
    user(state) {
      return state.user ? true : false
    },
  }
}